import EntryGrid from 'components/Inputs/EntryGrid';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, FormGroup, Button } from 'reactstrap';
import * as ItemTypeAction from 'store/actions/item_type';
import TextBox from 'components/Inputs/TextBox';
import { t } from 'i18next';
import { getCargoType } from 'utli';
import NumberInput from 'components/Inputs/NumberInput';
import { useFieldArray } from 'react-hook-form';

function ItemInfoForm({ register, errors, control, editData, getValues, watch, setValue }) {
  const dispatch = useDispatch();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'items',
  });

  React.useEffect(() => {
    // Initialize with one empty item if no fields exist
    if (fields.length === 0 && !editData) {
      append({
        itemname: '',
        unit: '',
        qty: 1,
        amount: '',
        remark: '',
      });
    }
  }, []);



  const handleAddItem = () => {
    append({
      itemname: '',
      unit: '',
      qty: 1,
      amount: '',
      remark: '',
    });
  };

  const handleRemoveItem = (index) => {
    if (fields.length > 1) {
      remove(index);
    }
  };

  return (
    <EntryGrid
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <span>{t('deposit_invoice.item_information')}</span>
          <Button
            color='primary'
            size='sm'
            type='button'
            onClick={handleAddItem}
          >
            <i className='fa fa-plus mr-2' />
            {t('add')}
          </Button>
        </div>
      }
    >
      {fields.map((field, index) => (
        <div key={field.id} style={{ marginBottom: '15px', paddingBottom: '15px', borderBottom: index < fields.length - 1 ? '1px solid #e0e0e0' : 'none' }}>
          <Row className='pt-1 pb-1'>
            <Col md={2} sm={6}>
              <FormGroup>
                <label>{t('deposit_invoice.item_name')}</label>
                <TextBox
                  className='form-control mr-2'
                  type='text'
                  registerProps={register(`items.${index}.itemname`, {
                    required: `${t('deposit_invoice.item_name')} ${t('is_required')}`,
                  })}
                  errors={errors?.items?.[index]?.itemname}
                />
              </FormGroup>
            </Col>
            <Col md={2} sm={6}>
              <FormGroup>
                <label>{t('deposit_invoice.unit')}</label>
                <TextBox
                  className='form-control mr-2'
                  type='text'
                  registerProps={register(`items.${index}.unit`, {
                    required: `${t('deposit_invoice.unit')} ${t('is_required')}`,
                  })}
                  errors={errors?.items?.[index]?.unit}
                />
              </FormGroup>
            </Col>
            <Col md={2} sm={6}>
              <FormGroup>
                <label>QTY</label>
                <TextBox
                  className='form-control mr-2'
                  type='number'
                  registerProps={register(`items.${index}.qty`, {
                    required: 'QTY is required',
                    valueAsNumber: true,
                  })}
                  errors={errors?.items?.[index]?.qty}
                  defaultValue={1}
                  onChange={(e) => {
                    setValue(`items.${index}.qty`, e.target.value);

                  }}
                />
              </FormGroup>
            </Col>
            <Col md={2} sm={6}>
              <FormGroup>
                <label>{t('deposit_invoice.amount')}</label>
                <TextBox
                  className='form-control mr-2'
                  type='number'
                  step='0.01'
                  registerProps={register(`items.${index}.amount`, {
                    required: `${t('deposit_invoice.amount')} ${t('is_required')}`,
                  })}
                  errors={errors?.items?.[index]?.amount}
                />
              </FormGroup>
            </Col>
            <Col md={3} sm={8}>
              <FormGroup>
                <label>{t('deposit_invoice.remark')}</label>
                <TextBox
                  className='form-control mr-2'
                  type='text'
                  registerProps={register(`items.${index}.remark`)}
                  errors={errors?.items?.[index]?.remark}
                />
              </FormGroup>
            </Col>
            <Col md={1} sm={4} style={{ display: 'flex', alignItems: 'flex-end' }}>
              <FormGroup style={{ marginBottom: '1rem' }}>
                <Button
                  color='danger'
                  size='sm'
                  type='button'
                  onClick={() => handleRemoveItem(index)}
                  disabled={fields.length === 1}
                  title={fields.length === 1 ? 'At least one item is required' : 'Remove item'}
                >
                  <i className='fa fa-trash' />
                </Button>
              </FormGroup>
            </Col>
          </Row>
        </div>
      ))}
    </EntryGrid>
  );
}
export default ItemInfoForm;
